export default "__VITE_ASSET__CpkCLLIQ__"